
import React from 'react';

interface ErrorsDisplayProps {
  errors: string[];
}

const ErrorsDisplay: React.FC<ErrorsDisplayProps> = ({ errors }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      <h4 className="font-semibold text-red-500 mb-1">Errors:</h4>
      <div className="max-h-20 overflow-auto text-[10px]">
        {errors.map((error, index) => (
          <div key={index} className="text-red-500 mb-1">{error}</div>
        ))}
      </div>
    </div>
  );
};

export default ErrorsDisplay;
